import * as basket from "../eaiws/basket";
export var defaultGetArticleDataOptions = new basket.GetArticleDataOptions();
defaultGetArticleDataOptions.noProperties = false;
defaultGetArticleDataOptions.fetchCatalogIcon = false;
defaultGetArticleDataOptions.fetchCatalogImage = true;
defaultGetArticleDataOptions.separateCurrencies = true;
